import Vue from 'vue';
import { GLOBAL_ERROR } from '@/utils/constants';
import { getQuote as getQuoteCall } from '../../api/quotes';

/**
 * Fetch a list of quotes by the given quoteIds.
 * This will delay each quote request by a given ms amount defined on the users
 * entity to prevent ERP 500 errors.
 *
 * @param commit Vuex lib commit
 * @param dispatch Vuex lib dispatch
 * @param state Vuex lib state
 * @param rootGetters Vuex lib root getters
 * @param quoteIds The list of quote ID's to fetch
 * @returns {Promise<*>}
 */
export function getQuotes(
  { commit, dispatch, state, rootGetters },
  quoteIds = []
) {
  return new Promise(async (resolve, reject) => {
    const delay = rootGetters['user/entityQueryDelay'];
    let iterate = 1;
    try {
      const promiseArr = [];
      quoteIds.forEach((id) => {
        if (!state.quotes[id] && !state.quotesLoading[id]) {
          commit('setQuoteLoading', id);
          promiseArr.push(
            new Promise(async (resolve) => {
              await new Promise((res) => setTimeout(res, delay * iterate));
              const result = await getQuoteCall(id)
                .then((quote) => commit('setQuote', quote))
                .catch(() => commit('setQuoteError', id));
              resolve(result);
            })
          );
          iterate += 1;
        }
      });
      return Promise.all(promiseArr).then(() => resolve());
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getQuotes')
      });
      return reject();
    }
  });
}
